import { buildSavedViewFiltersJson, parseSavedViewFilters } from '../../shared/saved-views/saved-view-filters';

export interface TestdatenblattSavedViewFilters {
  query: string | null;
  author: string | null;
}

const EMPTY_FILTERS: TestdatenblattSavedViewFilters = { query: null, author: null };

export function parseTestdatenblattSavedViewFilters(filtersJson: string | null): TestdatenblattSavedViewFilters {
  return parseSavedViewFilters(filtersJson, EMPTY_FILTERS);
}

export function buildTestdatenblattSavedViewFiltersJson(filters: TestdatenblattSavedViewFilters): string {
  return buildSavedViewFiltersJson(filters);
}
